/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import { Easing, Tween } from '../../Utility/Tween';
import { GetReelEventName, ReelEvent } from '../ReelEvent';
import ReelActionBase from './ReelActionBase';
import { SpinStates } from './SpinStates';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Handles the ramp-up effect for accellerating a [[Reel]] up to its spin speed. */
@cc._decorator.ccclass
export default class RampUp extends ReelActionBase
{
    protected duration: number = 0.15;

    /** Max speed to ramp up to. */
    @property({ visible: true })
    private _maxSpeed: number = 28;
    /** @hidden */
    private _curSpeed: number = 0;

    /** @hidden */
    public get IsComplete(): boolean { return Math.abs(this._curSpeed) >= Math.abs(this._maxSpeed); }

    /** @hidden */
    protected start(): void
    {
        super.start();

        this.reel.node.on(GetReelEventName(ReelEvent.OnResetSpinning), () => this.SetMaxSpeed());
    }

    /** @hidden */
    protected reset(): void
    {
        this.elapsedTime = 0;
        this._curSpeed = 0;

        if (this.reel.SpinningUp)
        {
            if (this._maxSpeed > 0) { this._maxSpeed *= -1; }
        }
        else
        {
            if (this._maxSpeed < 0) { this._maxSpeed *= -1; }
        }
    }

    /** @hidden */
    protected update(dt: number): void
    {
        super.update(dt);

        dt = this.dtModObservable.Multiply(dt);
        let timeProgress: number = this.elapsedTime / this.duration;
        this._curSpeed = Tween.TweenNumber(0, this._maxSpeed, timeProgress, Easing.Quadratic);
        this.reel.SpinSpeed = this._curSpeed;
        this.elapsedTime += dt;

        if (this.IsComplete)
        {
            this.reel.SetSpinState(SpinStates.Spinning);
        }
    }

    /** Sets current speed to max speed. */
    public SetMaxSpeed(): void
    {
        // Skip cockback.
        this.reel.SetSpinState(SpinStates.RampingUp);

        this._curSpeed = this._maxSpeed;
    }
}
